/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { ClientCaseModel } from '../models/client-case-model';
import { getClientCase$Json } from '../fn/case/get-client-case-json';
import { GetClientCase$Json$Params } from '../fn/case/get-client-case-json';
import { getClientCase$Plain } from '../fn/case/get-client-case-plain';
import { GetClientCase$Plain$Params } from '../fn/case/get-client-case-plain';
import { sendSurvey$Json } from '../fn/case/send-survey-json';
import { SendSurvey$Json$Params } from '../fn/case/send-survey-json';
import { sendSurvey$Plain } from '../fn/case/send-survey-plain';
import { SendSurvey$Plain$Params } from '../fn/case/send-survey-plain';
import { SendSurveyResponse } from '../models/send-survey-response';

@Injectable({ providedIn: 'root' })
export class CaseService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getClientCase()` */
  static readonly GetClientCasePath = '/api/Case/{caseId}';

  /**
   * get case by id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getClientCase$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  getClientCase$Plain$Response(params: GetClientCase$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ClientCaseModel>> {
    return getClientCase$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * get case by id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getClientCase$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getClientCase$Plain(params: GetClientCase$Plain$Params, context?: HttpContext): Observable<ClientCaseModel> {
    return this.getClientCase$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ClientCaseModel>): ClientCaseModel => r.body)
    );
  }

  /**
   * get case by id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getClientCase$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  getClientCase$Json$Response(params: GetClientCase$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ClientCaseModel>> {
    return getClientCase$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * get case by id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getClientCase$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getClientCase$Json(params: GetClientCase$Json$Params, context?: HttpContext): Observable<ClientCaseModel> {
    return this.getClientCase$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<ClientCaseModel>): ClientCaseModel => r.body)
    );
  }

  /** Path part for operation `sendSurvey()` */
  static readonly SendSurveyPath = '/api/Case/{caseId}/SendSurvey';

  /**
   * send a survey to the client associated with the case.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `sendSurvey$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  sendSurvey$Plain$Response(params: SendSurvey$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<SendSurveyResponse>> {
    return sendSurvey$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * send a survey to the client associated with the case.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `sendSurvey$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  sendSurvey$Plain(params: SendSurvey$Plain$Params, context?: HttpContext): Observable<SendSurveyResponse> {
    return this.sendSurvey$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<SendSurveyResponse>): SendSurveyResponse => r.body)
    );
  }

  /**
   * send a survey to the client associated with the case.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `sendSurvey$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  sendSurvey$Json$Response(params: SendSurvey$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<SendSurveyResponse>> {
    return sendSurvey$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * send a survey to the client associated with the case.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `sendSurvey$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  sendSurvey$Json(params: SendSurvey$Json$Params, context?: HttpContext): Observable<SendSurveyResponse> {
    return this.sendSurvey$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<SendSurveyResponse>): SendSurveyResponse => r.body)
    );
  }

}
